import { render, staticRenderFns } from "./BlockSlider.vue?vue&type=template&id=cf211198&scoped=true&"
import script from "./BlockSlider.vue?vue&type=script&lang=js&"
export * from "./BlockSlider.vue?vue&type=script&lang=js&"
import style0 from "./BlockSlider.vue?vue&type=style&index=0&id=cf211198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf211198",
  null
  
)

export default component.exports